module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-12-645d6fc24a303d957ce26333143725dd.webp";